import { render, staticRenderFns } from "./goodsSyncCheck.vue?vue&type=template&id=6cb65ad4&scoped=true"
import script from "./goodsSyncCheck.vue?vue&type=script&lang=js"
export * from "./goodsSyncCheck.vue?vue&type=script&lang=js"
import style0 from "./goodsSyncCheck.vue?vue&type=style&index=0&id=6cb65ad4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb65ad4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cb65ad4')) {
      api.createRecord('6cb65ad4', component.options)
    } else {
      api.reload('6cb65ad4', component.options)
    }
    module.hot.accept("./goodsSyncCheck.vue?vue&type=template&id=6cb65ad4&scoped=true", function () {
      api.rerender('6cb65ad4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/goods/goodsSyncCheck.vue"
export default component.exports